import React from 'react';
import { DevicePreviewSkeleton } from "../DevicePreviewSkeleton";
export var ContentWrapper = function ContentWrapper(_ref) {
  var isLoading = _ref.isLoading,
    size = _ref.size,
    children = _ref.children;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(DevicePreviewSkeleton, {
      size: size
    });
  }
  return children;
};